import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {NotificationsListHeader} from './components/header/NotificationsListHeader'
import {NotificationsTable} from './table/NotificationsTable'
import {NotificationEditModal} from './notification-edit-modal/NotificationEditModal'
import { KTCard } from '../../../../../_metronic/helpers'
// import { KTCard } from '../../../../_metronic/helpers'
// import {KTCard} from '../../../../../_metronic/helpers'

const NotificationsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      
        {/* <NotificationsListHeader /> */}
        <NotificationsTable />
      
      {itemIdForUpdate !== undefined && <NotificationEditModal />}
    </>
  )
}

const NotificationsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <NotificationsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {NotificationsListWrapper}
